//=============================================//
//=============== APP Constants ===============//
//=============================================//

// FORCE BILLING
export const forceBillingGroups = ['7434', '7621', '7345']; // jo2024, jo2024para, Ministère de la Justice

// API
export const API_QUERY_PLACEHOLDER = 'QUERY';

// TABLE
export const DEFAULT_ROW_NUMBER = 20;
// Choices offered to the user in the "rows per page" selector, first one is the default
export const ROW_NUMBER_OPTIONS = [DEFAULT_ROW_NUMBER, 50, 100];

// MAD
export const MAX_MAD_TIME = 12;

// FORM
export const FORM_DEFAULT_DEBOUNCE_TIME = 500;

// MAP
export const CIRCLE_COLOR_DEFAULT = '#8E24AA';
export const CIRCLE_COLOR_SELECTED = '#0000FF';

// SNACKBAR
export const SNACKBAR_DURATION = 5000;

// DOCUMENTS
export const ACCEPTED_UPLOAD_TYPE: string = 'image/*, application/pdf';

export const dateMask = 'dd mmmm yyyy à HH:MM';
export const dateShort = 'dd/MM/yyyy';

// COLORS
export const orange = '#FFA002';
export const blue = '#1542C3';
export const lightBlue = '#62A5D1';
export const red = '#F15464';
export const green = '#00C4B4';
export const grey = '#C0C8CE';

// TOKEN
export const TOKEN_RENEW_THRESHOLD = 5 * 60 * 1000; // 5 minutes

// RIDES IMPORT
export const RIDES_IMPORT_MAX_PRICE = 499;
export const RIDES_IMPORT_SIX_MONTHS_MS = 1000 * 60 * 60 * 24 * 30 * 6;

// FEATURE FLAGS
/**
 * LT-876 - the user sheet reads the plural `companies` field and names the
 * membership it moves through `from_group_uuid`. `id` serves both since its own
 * LT-876 (#597, #601).
 *
 * An `id` without that fix sends no `companies` and ignores `from_group_uuid`,
 * so the sheet falls back to the singular `company` there: one block, and the
 * request that `id` already answers. Set it back to false to keep to that shape
 * everywhere.
 *
 * LT-881 - it also shows the Multigroupe checkbox on the parent company's
 * contract settings. Activating it is one-way: `id` refuses the on -> off
 * transition until LT-1941 ships the controlled deactivation.
 */
export const FEATURE_MULTIGROUP = false;
